import { h, Component } from "preact";
import { route } from "preact-router";
import linkState from 'linkstate';

import { getApiPath } from "../../../../../path";

import AdminMenu from "../../../../../components/admin/menu";
import AdminMenuPoetry from "../../../../../components/admin/menu/poetry";
import Editor from "../../../../../components/admin/editor";

class AdminPoetryEditLiterature extends Component {
  state = {
    keywordlist: [],
    authorlist: [],
    formSubmitted: false,
    formValid: false,
    formData: {
      toon: false,
      titel: "",
      samenvatting: "",
      over_werk: "",
      id_auteur: "",
      trefwoorden: [{}],
    }
  };

  constructor(props) {
    super(props);
    this.editorHandler = this.editorHandler.bind(this);
    this.ApiGetInfo();
  }

  editorHandler(name, newContent) {
    this.state.formData[name] = newContent;
  }

  ApiGetInfo = () => {
    let fetchPath = getApiPath(this.props.lang, `adminPoetry/lists`);
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      }
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        this.setState(previousState => ({
          ...previousState,
          keywordlist: result.data["keywords"],
          authorlist: result.data["authors"]
        }))
    }});

    fetchPath = getApiPath(this.props.lang, `adminPoetry/detail/${this.props.id}`);
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      }
    })
      .then(res => res.json())
      .then(result => {
        if (result.status == 200) {
          this.setState(previousState => ({
            ...previousState,
            formData: {
              toon: result.data["toon"] == 1 ? true : false,

              titel: result.data["titel"],
              land: result.data["land"],
              jaar: result.data["jaar"],
              samenvatting: result.data["samenvatting"],
              trefwoorden: result.data["trefwoorden"],
              id_auteur: result.data["id_auteur"]
            }
          }));
        }
      });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.state.formData.trefwoorden = Array.from(document.getElementById("trefwoorden").selectedOptions).map(o => parseInt(o.value));

    this.setState(previousState => ({
      ...previousState,
      formSubmitted: true
    }), this.validateForm());
  }

  validateForm = () => {
    if ( // required fields
      this.state.formData.titel == "" ||
      this.state.formData.id_auteur == "" ||
      this.state.formData.trefwoorden.length == 0
    ) {
      this.setState(previousState => ({
        ...previousState,
        formValid: false
      }));
    }else{
      this.setState(previousState => ({
        ...previousState,
        formValid: true
      }), this.doSubmit());
    }
  }

  doSubmit = () => {
    let fetchPath = getApiPath(this.props.lang, `adminPoetry/literature/${this.props.id}`);
    fetch(fetchPath, {
      method: 'post',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      },
      body: JSON.stringify(this.state.formData)
    })
      .then(res => res.json())
      .then(result => {
        if (result.status == 200) {
          route(`/${this.props.lang}/admin/poetry/literature`);
        } else {
          alert("Something went wrong");
        }
      });
  }

  render() {
    return (
      <div class="admin-page">
        <AdminMenu locale={this.props.lang} />
        <AdminMenuPoetry locale={this.props.lang} />
        <div>
          <h2>{this.props.lang=='nl'? 'Bewerk boek':'Edit book'}</h2>
          <article>
            <form class="admin-form" onSubmit={this.handleSubmit}>
              <div class="form-group">
                <label for="toon">{this.props.lang=='nl'? 'Zichtbaar op website?':'Visible on website?'}</label>
                <input type="checkbox" name="toon" id="toon" checked={this.state.formData.toon} onInput={linkState(this, 'formData.toon')} />
              </div>

              <div class="form-group">
                <label for="trefwoorden">{this.props.lang=='nl'?'Trefwoorden':'Keywords'} <span class="req">*</span></label>
                <select name="trefwoorden" id="trefwoorden" multiple size="10">
                  {this.state.keywordlist.map(tList => {
                    return (<option
                      selected={this.state.formData.trefwoorden.findIndex(t => parseInt(t.id) == tList.id) != -1 }
                      value={tList.id}>{tList.trefwoord}
                    </option>);
                  })}
                </select>
              </div>

              <div class="form-group">
                <label for="titel">{this.props.lang=='nl'?'Titel':'Title'}<span class="req">*</span></label>
                <input type="text" name="titel" id="titel" value={this.state.formData.titel} onInput={linkState(this, 'formData.titel')} />
              </div>

              <div class="form-group">
                <label for="id_auteur">{this.props.lang=='nl'?'Auteur':'Author'} <span class="req">*</span></label>
                <select name="id_auteur" id="id_auteur" value={this.state.formData.id_auteur} onInput={linkState(this, 'formData.id_auteur')}>
                  <option>{this.props.lang=='nl'?'Kies een auteur':'Choose an author'}</option>
                  {this.state.authorlist.map(a => {
                    return (<option
                      selected={a.id == this.state.formData.id_auteur}
                      value={a.id}>{a.achternaam}, {a.voornaam}{a.tussenvoegsel != "" ? ", " + a.tussenvoegsel : ""}
                    </option>);
                  })}
                </select>
              </div>

              <div class="form-group">
                <label for="samenvatting">{this.props.lang=='nl'?'Gedicht':'Poem'}</label>
                <Editor name="samenvatting" content={this.state.formData.samenvatting} afterChange={this.editorHandler} />
              </div>

              <div class="form-group">
                <label for="over_werk">{this.props.lang=='nl'?'Over gedicht':'About poem'}</label>
                <Editor name="over_werk" content={this.state.formData.over_werk} afterChange={this.editorHandler} />
              </div>
              
              {(this.state.formSubmitted && !this.state.formValid) &&
                <div class="form-group">
                    {this.props.lang=='nl'? 'Controleer of alle verplichte velden zijn ingevuld. Deze zijn gemarkeerd met' : 'Please check that all required fields are filled in. These are marked with' } <span class="req">*</span>
                </div>
              }
              
              <div class="form-group">
                <button>{this.props.lang=='nl'? 'Opslaan':'Save'}</button>
              </div>
            </form>
          </article>
        </div>
      </div>
    );
  }
}

export default AdminPoetryEditLiterature;
